// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-tabs__nav-scroll{display:flex!important;justify-content:center!important;align-items:center!important}.el-tabs__active-bar{border-radius:24px 24px 0 0;height:5px}.el-tabs__item.is-active{color:#222;font-weight:700}.el-tabs__item{color:#9a9a9a}.text-blue{color:#48bfe3!important}", ""]);
// Exports
module.exports = exports;
